export enum ExemptionChannel {
  EMAIL = 'email',
  PUSH = 'push',
}
